import { PageLayout } from "@ezmid/components-library";
import { useTranslation } from "react-i18next";

import { LecturerAddPageContent } from "../organisms/LecturerAddPageContent";

export function LecturerAddPage() {
  const { t } = useTranslation();

  return (
    <PageLayout title={t("app.page.lecturers.heading")}>
      <LecturerAddPageContent />
    </PageLayout>
  );
}
